import React from "react";
// Importing new icons for a consistent look and gray theme
import { FaSyncAlt, FaTruck, FaBan, FaRulerCombined, FaLock } from "react-icons/fa";

const benefits = [
  {
    icon: <FaSyncAlt className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 text-gray-700" />,
    label: "7 Days Returns",
    bgColor: "bg-gray-100", // Changed to gray background
  },
  {
    icon: <FaTruck className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 text-gray-700" />,
    label: "Free Delivery",
    bgColor: "bg-gray-100", // Changed to gray background
  },
  {
    icon: <FaBan className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 text-gray-700" />,
    label: "No Harmful Chemicals",
    bgColor: "bg-gray-100", // Changed to gray background
  },
  {
    icon: <FaRulerCombined className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 text-gray-700" />,
    label: "Customize Size & Style",
    bgColor: "bg-gray-100", // Changed to gray background
  },
  {
    icon: <FaLock className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 text-gray-700" />,
    label: "Secure Transaction",
    bgColor: "bg-gray-100", // Changed to gray background
  },
];

const BenefitsSlider = () => {
  return (
    <div className="mt-5 px-4 md:px-12">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {benefits.map((item, idx) => {
          const isLastItem = idx === benefits.length - 1;
          return (
            <div
              key={idx}
              className={`flex flex-col items-center text-center border border-gray-200 rounded-xl px-3 py-2 shadow-sm bg-white transition-transform hover:scale-105 ${
                isLastItem ? "col-span-2 sm:col-span-1 justify-self-center" : ""
              }`}
            >
              <div
                className={`mb-1 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full ${item.bgColor} shadow-inner`}
              >
                {item.icon}
              </div>
              <p className="text-xs md:text-sm font-medium text-gray-500 leading-tight">
                {item.label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BenefitsSlider;
